import { BlankResponse } from '../../../models/LessonComponentContent';
import { FillBlankComponent } from 'content/models/LessonComponent';
import { FillGapRecursiveElement } from './FillGapRecursiveElement';
import React from 'react';

interface IFillGapComponentProps {
  html: string;
  component: FillBlankComponent;
  answers: BlankResponse[];
  onChange: (id: string, answer: string) => void;
}
/** The component that renders the paragraph containing blanks. */
export const FillGapComponent = (props: IFillGapComponentProps) => {
  const { html } = props;
  const elementNode = document.createElement('div');
  elementNode.innerHTML = html;
  return (
    <span className="ql-editor ql-editor-fill-the-blank">
      <FillGapRecursiveElement {...props} node={elementNode} />
    </span>
  );
};
